/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SmtpSettings { 
    id: string;
    transport?: string;
    smtpHost?: string;
    smtpPort?: string;
    smtpUsername?: string;
    smtpPassword?: string;
    smtpSenderName?: string;
    senderId?: string;
    receiverId?: string;
    enableSSL: boolean;
    usedeliveryserviceEmail: boolean;
    defaultLocalizationLanguageName?: string;
}
